var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgAsk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.625 30.375C28.625 27.0613 31.3113 24.375 34.625 24.375H82.625C85.9387 24.375 88.625 27.0613 88.625 30.375V82.125C88.625 85.4387 85.9387 88.125 82.625 88.125H34.625C31.3113 88.125 28.625 85.4387 28.625 82.125V30.375Z",
    fill: "#F39C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5625 7.875H66.5C69.8137 7.875 72.5 10.5613 72.5 13.875V69.75C72.5 73.0637 69.8137 75.75 66.5 75.75H14.375C11.0613 75.75 8.375 73.0637 8.375 69.75V31.875L32.5625 7.875Z",
    fill: "#FCF1BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5625 7.875V25.875C32.5625 29.1887 29.8762 31.875 26.5625 31.875H8.375L32.5625 7.875Z",
    fill: "#F4D88C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4375 38.0625C22.4375 36.9234 23.3609 36 24.5 36H56.5625C57.7016 36 58.625 36.9234 58.625 38.0625C58.625 39.2016 57.7016 40.125 56.5625 40.125H24.5C23.3609 40.125 22.4375 39.2016 22.4375 38.0625Z",
    fill: "#422B00",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4375 48C22.4375 46.8609 23.3609 45.9375 24.5 45.9375H56.5625C57.7016 45.9375 58.625 46.8609 58.625 48C58.625 49.1391 57.7016 50.0625 56.5625 50.0625H24.5C23.3609 50.0625 22.4375 49.1391 22.4375 48Z",
    fill: "#422B00",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4375 57.9375C22.4375 56.7984 23.3609 55.875 24.5 55.875H42.5C43.6391 55.875 44.5625 56.7984 44.5625 57.9375C44.5625 59.0766 43.6391 60 42.5 60H24.5C23.3609 60 22.4375 59.0766 22.4375 57.9375Z",
    fill: "#422B00",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3125 57.9375C48.3125 56.7984 49.2359 55.875 50.375 55.875H56.5625C57.7016 55.875 58.625 56.7984 58.625 57.9375C58.625 59.0766 57.7016 60 56.5625 60H50.375C49.2359 60 48.3125 59.0766 48.3125 57.9375Z",
    fill: "#422B00",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAsk);
export default __webpack_public_path__ + "static/media/img_ask.9f3660a10c640e9f1049a7d35ad3b9fa.svg";
export { ForwardRef as ReactComponent };